/**
 * オリジナル印刷商品向け:
 * Shopify アプリスクリプトは window.load 後に Zakeke product.js を読むため遅い。
 * 商品ページでは先に同じ URL を読み込む。
 */
(function () {
  var ZAKEKE_SCRIPT_SRC =
    'https://portal.zakeke.com/Scripts/integration/shopify/product.js?shop=' +
    (window.Shopify && Shopify.shop ? Shopify.shop : '');

  if (!ZAKEKE_SCRIPT_SRC || ZAKEKE_SCRIPT_SRC.endsWith('shop=')) return;
  if (document.querySelector('script[data-zakeke-early="true"]')) return;
  if (document.querySelector('script[src*="portal.zakeke.com/Scripts/integration/shopify/product.js"]')) {
    return;
  }

  var script = document.createElement('script');
  script.src = ZAKEKE_SCRIPT_SRC;
  script.async = true;
  script.dataset.zakekeEarly = 'true';
  document.head.appendChild(script);
})();
